import { loginRequiredActive, userOrAdminActive } from '@/componentRouter.active';

/**
 *
 * @param $stateProvider
 */
export default function usersRouter(
  $stateProvider
) {

  'ngInject';

  $stateProvider
    .state({
      name: 'userDetail',
      url: '/users/:id/detail',
      template: '<users-detail></users-detail>',
      resolve: {
        loginRequiredActive: loginRequiredActive,
        userOrAdmin: userOrAdminActive
      }
    })
    .state({
      name: 'userUpdate',
      url: '/users/:id/update',
      template: '<users-update></users-update>',
      resolve: {
        loginRequiredActive: loginRequiredActive,
        userOrAdmin: userOrAdminActive
      }
    })
    .state({
      name: 'adminUserCreate',
      url: '/admin/companies/:id/users/create',
      template: '<users-create></users-create>',
      resolve: {
        loginRequiredActive: loginRequiredActive,
        userOrAdmin: userOrAdminActive
      }
    });

}


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users.router.js
 **/